import { Box, Button, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from '../../../../../components/ui-component/form-component/create-form/CreateForm';
import LoadingIconOnly from '../../../../../components/ui-component/loading/LoadingIconOnly';
import MuiSnackbar from '../../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from '../../../../../context/AuthContext';
import GetRecord from '../../../../../lib/api/GetRecord';
import { PostRecord } from '../../../../../lib/api/PostRecord';
import PutRecord from '../../../../../lib/api/PutRecord';
import { APIS } from '../../../../../lib/constants/apis';
import { NOT_FOUND_ERROR_MESSAGE } from '../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../lib/types/types';
import { removeDataKeys, removeNullDeep } from '../../../../../utils/helper';
import OrganisationDataValidator from './OrganisationDataValidator';

// import Schemas
import Schema from '../../../../../lib/paths/unternehmen_FULL_Paths.json';
let P = Schema.attributes;

const formStruc: FormStrucItem[] = [
	{ fields: [P.Geschaeftsbezogene_Daten_Name_Der_Organisation] },
	{ fields: [P.Adressdaten_Adresszusatz, P.Adressdaten_Strasse_Und_Hausnummer]},
	{ fields: [P.Adressdaten_PLZ, P.Adressdaten_Ort] },
	{ fields: [P.Kontaktdaten_E_Mail, P.Kontaktdaten_Fax] },
	{ fields: [P.Kontaktdaten_Telefon, P.Kontaktdaten_Webadresse] },
	{ fields: [P.Geschaeftsbezogene_Daten_Kurzbeschreibung_Der_Organisation], userProps: { direction: 'column', columnToDivide: 1 } },
];
const OrganisationData: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [loading, setLoading] = useState<boolean>(true);
	const [updateSuccess, setUpdateSuccess] = useState<boolean | null>(null);
	const [wsError, setWsError] = useState<boolean>(false);
	const [organisationData, setOrganisationData] = useState<Record<string, any>>({});
	const [formErrors, setFormErrors] = useState<Record<string, any>>({});

	const handleInputChange = (path: string, value: any) => {
		setUpdateSuccess(null);
		let organisationDataCopy = cloneDeep(organisationData);
		set(organisationDataCopy, path, value);
		setOrganisationData(organisationDataCopy);
	};
	const validateOrganisationData = () => {
		let errorObject = {};
		let errs = OrganisationDataValidator.validate(organisationData);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setFormErrors(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const handleUpdateOrganisationData = async () => {
		if (validateOrganisationData()) {
			let res = await PutRecord(APIS.Organisation, get(authenticatedData, 'organisationId'), {
				data: get(organisationData, 'attributes'),
			});
			if (get(res, 'data.id')) {
				let pushNotificationData = { data: { entities: [{ api: APIS.Organisation, id: get(res, 'data.id') }] } };
				await PostRecord(APIS.PushNotificaiton, pushNotificationData);
				setUpdateSuccess(true);
			}
		}
	};

	useEffect(() => {
		const fetchOrganisation = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Organisation, get(authenticatedData, 'organisationId'));
				setOrganisationData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Organisation ', err);
				setWsError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchOrganisation();
	}, [authenticatedData]);

	if (loading) return <LoadingIconOnly />;
	return (
		<>
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage={NOT_FOUND_ERROR_MESSAGE} error={wsError} />
			<MuiSnackbar showSnackbar={updateSuccess} closeSnackbar={() => setUpdateSuccess(null)} alertMessage='Daten wurde aktualisiert' />
			<Typography variant='h3' component='h2'>
				Daten meiner Organisation
			</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={organisationData}
				formErrors={formErrors}
				updateFormValuesFunc={handleInputChange}
				api={APIS.Organisation}
			/>

			<Box sx={{ textAlign: 'right', mt: '2rem' }}>
				<Button onClick={handleUpdateOrganisationData}>Aktualisieren</Button>
			</Box>
		</>
	);
};
export default OrganisationData;
